// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-form-message[data-v-a94d49d2]{--local-font-color:var(--color-text-2);color:var(--color-text-2);color:var(--local-font-color);font-size:var(--font-size-sm-2);font-weight:var(--font-weight-normal);line-height:var(--line-height-tight);margin:var(--spacing-sm-2) 0 0;min-height:calc(var(--font-size-sm-2)*var(--line-height-tight))}.base-form-message--invalid[data-v-a94d49d2]{--local-font-color:var(--color-error)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
